import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ConfigService } from 'src/services/config.service';
import { AuthGaurdService } from 'src/services/auth-gaurd.service';
import { SHARED_IMPORTS } from 'src/app/shared/shared.module';

@Component({
  selector: 'app-participant-disqualify-demographic',
  templateUrl: './participant-disqualify-demographic.component.html',
  styleUrls: ['./participant-disqualify-demographic.component.css'],
  standalone: true,
  imports: [...SHARED_IMPORTS]
})
export class ParticipantDisqualifyDemographicComponent implements OnInit {
  demographic_DisqualifyMsg: string;
  isAdmin: boolean;
  studyId: string;
  constructor(private router: Router, private configService: ConfigService, private authGaurd: AuthGaurdService, private route: ActivatedRoute) { }

  @ViewChild('hiddenInput', { static: true }) hiddenField: ElementRef;

  ngOnInit() {

    this.isAdmin = this.authGaurd.isAdmin.toLowerCase() == "true" ? true : false;
    this.studyId = this.route.snapshot.params["studyid"];

    this.configService.getAppConfigByKey('Participant_Demo_Disqualify_Message').subscribe(response => {
      this.demographic_DisqualifyMsg = response.valText;
    });
    this.hiddenField.nativeElement.focus();
  }
  callParticipantHome(): void {
    this.router.navigateByUrl('');
  }
  callAdminHome(): void {
    this.router.navigate(['/adminhome/studydetail/', this.studyId], { fragment: 'display', skipLocationChange: true });
  }
}
